export enum VIEWS {
  PLAYER = 'PLAYER',
  DETAILS = 'DETAILS',
}
